'use client';

import React from 'react';
import styled from '@emotion/styled';
import { KbbLogo, Link, Divider } from "@argo/ui-elements";
import { size, breakpoints } from "@argo/principles";
import PrimaryNavItem from './components/PrimaryNavItem';
import MobileNav from './components/MobileNav';
import NavLinks from './components/NavLinks';
import { navbp, RIBBON_HEIGHT, RIBBON_WIDTH, NAV_HEIGHT } from './utils/constants';
import { GLOBALNAV_KBB_BASE_URL } from '../mykbb/utils/constants';
const DesktopNav = styled('nav')`
  display: none;
  padding: 0 ${size.md}px;
  right: 0;
  white-space: nowrap;

  @media (min-width: ${navbp.extraWideViewport}) {
    position: relative;
    padding: 0;
    display: flex;
    align-items: center;
    ${props => props.withMyKbb ? '' : 'margin-right: 73px;'}
  }
`;
const LogoContainer = styled.div`
  flex-grow: 2;
  position: relative;
  z-index: 11;

  > a {
    display: inline-block;
    margin-left: ${size.sm}px;
    height: ${NAV_HEIGHT}px;
    

    div {
      height: ${NAV_HEIGHT}px;
      max-width: 250px;
      position: relative;
      align-items: initial;
      justify-content: left;

      > img {
        margin-top: -2px;
      }
      
    }
  }

  @media (min-width: ${breakpoints.md}px) {
    a div {
      max-width: 280px;
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    a {
      margin-left: ${size.md}px;
    }
  }
`;
const NavDivider = styled(Divider)`
  margin-bottom: ${size.xs}px;
  margin-top: -10px;
`;
export const Logo = () => React.createElement(LogoContainer, null, React.createElement(Link, {
  href: "/",
  "data-tag-id": "1"
}, React.createElement(KbbLogo, {
  "data-analytics": "kbblogo_global",
  "data-partner": "nx",
  height: RIBBON_HEIGHT,
  width: RIBBON_WIDTH,
  textViewbox: '0 0 200 36',
  s: true,
  textHeight: '36px'
})));
export const DesktopNavBase = ({
  links,
  withMyKbb,
  isDataFromAPI,
  pageId
}) => {
  if (!isDataFromAPI && typeof window !== 'undefined') {
    console.warn('Global-nav fallback headerlinks are used instead of latest navigation in s3 bucket file.');
  }
  return React.createElement(DesktopNav, {
    withMyKbb: withMyKbb
  }, React.createElement(NavLinks, {
    links: links,
    isDesktopView: true,
    pageId: pageId
  }));
};
export const MobileNavBase = ({
  navMenuLegal,
  links,
  onMenuClick,
  menuOpenState,
  pageId
}) => {
  return React.createElement(MobileNav, {
    onMenuClick: onMenuClick,
    menuOpenState: menuOpenState
  }, React.createElement(NavLinks, {
    links: links,
    pageId: pageId
  }), navMenuLegal && React.createElement(NavDivider, null), navMenuLegal && navMenuLegal.map((link, i) => React.createElement(PrimaryNavItem, {
    key: i
  }, React.createElement(Link, {
    "data-analytics": link.omnitureTag,
    "data-partner": link.partnerLink,
    "data-tag-id": `NavMenuLegal${i}`,
    href: `${GLOBALNAV_KBB_BASE_URL}${link.url}`,
    dangerouslySetInnerHTML: {
      __html: link.name
    }
  }))));
};